import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { UsageView } from "../../views"
import { UsageService, ChatbotService } from "../../../services"
import { useGlobalState } from "../../../GlobalState"
import moment from "moment"

const UsageAction = () =>{
  const history = useHistory()
  const url = process.env.REACT_APP_ETICKET_API
  const usageService = new UsageService(url)
  const chatbotService = new ChatbotService(url)
  const token = JSON.parse(localStorage.getItem('token')).accessToken
  const { botConfig } = useGlobalState()

  const [usagePart1, setUsagePart1] = useState(null)

  const [dailyTokenUsage, setDailyTokenUsage] = useState(null)
  const [sentimentData, setSentimentData] = useState(null)
  const [sentimentEnabled, setSentimentEnabled] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [date, setDate] = useState(parseInt(moment().format('YYYYMM')))

  const monthYearOptions = Array.from({ length: 12 }, (_, i) => {
        const monthDate = moment().subtract(i, 'months')
        const value = parseInt(monthDate.format('YYYYMM'))
        return {
            value,
            text: monthDate.format('MMMM YYYY')
        }
    }).reverse()
  // const [dates, setDates] = useState({ startDate: moment().subtract(1, 'year').toDate(), endDate: moment().toDate()})
  // const [periodType, setPeriodType] = useState("year") // "year" | "month" | "week" | "day"

    const handleChangeDate = (event) => {
        setDate(event.target.value.value)
    }

    // Navega al Historial con la Búsqueda Avanzada preseleccionada: mes completo del periodo
    // actual y el sentimiento de la tarjeta pulsada.
    const handleSentimentClick = (sentiment) => {
        history.push({
            pathname: '/history',
            state: { advancedSearch: { sentiment, period: date } }
        })
    }

  const getData = async () => {
    try {
      setIsLoading(true)
      const monthNumber = date % 100
      const yearNumber = Math.floor(date / 100)

      // Fetching usage data
      const [usagePart1P, dailyTokenUsageP, sentimentReportP, botConfigP] = await Promise.all([
            usageService.getUsagePart1Passthrough(yearNumber, monthNumber, token, botConfig?.id || null),
            usageService.getDailyTokenUsage(yearNumber, monthNumber, botConfig?.id, token),
            usageService.getSentimentAnalysisReport(yearNumber, monthNumber, token, botConfig?.id),
            botConfig?.id ? chatbotService.getChatbotConfig(botConfig.id) : Promise.resolve(null),
          ])

      setUsagePart1(usagePart1P)
      setDailyTokenUsage(dailyTokenUsageP)
      setSentimentData(sentimentReportP)
      setSentimentEnabled(!!botConfigP?.sentimentAnalysisEnabled)
      setIsLoading(false)
    } catch (error) {
      console.error("Error in UsageAction:", error)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (botConfig?.id) getData()
  }, [date, botConfig?.id])
  
  return (
    <UsageView 
      isLoading={isLoading}
      usagePart1={usagePart1}
      dailyTokenUsage={dailyTokenUsage}
      sentimentData={sentimentData}
      date={date}
      handleChangeDate={handleChangeDate}
      monthYearOptions={monthYearOptions}
      sentimentEnabled={sentimentEnabled}
      handleSentimentClick={handleSentimentClick}
      onRefresh={getData}
    />
  )
}

export { UsageAction as default }